import { IContactForEdit } from './contact-for-edit'
import { Button, Col, ControlLabel, Form, FormControl, FormGroup, Well } from 'react-bootstrap'
import { DeleteWrapper } from '../styles';

interface IProps {
    data: IContactForEdit,
    onYes: () => void,
    onNo: () => void
}

const ConfirmDeleteContact = (props: IProps) => {
    let { firstName, lastName, email } = props.data;

    return (
        <Well bsStyle='danger' style={{ marginBottom: 0 }}>
            <h4 style={{ marginTop: 0 }}>Please confirm that you wish to delete the following contact...</h4>

            <DeleteWrapper horizontal>
                <FormGroup>
                    <Col xs={12} sm={4} componentClass={ControlLabel}>First Name:</Col>
                    <Col xs={12} sm={8} componentClass={FormControl.Static}>{firstName}</Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} sm={4} componentClass={ControlLabel}>Last Name:</Col>
                    <Col xs={12} sm={8} componentClass={FormControl.Static}>{lastName}</Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} sm={4} componentClass={ControlLabel}>Email Address:</Col>
                    <Col xs={12} sm={8} componentClass={FormControl.Static}>{email}</Col>
                </FormGroup>
            </DeleteWrapper>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button bsStyle='danger' onClick={props.onYes}>Yes, Delete</Button>&nbsp;
                <Button onClick={props.onNo}>No, Cancel</Button>
            </div>
        </Well>
    );
}

export default ConfirmDeleteContact;